import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

export const MarqueeText = ({ 
  children, 
  direction = 'left',
  speed = 25,
  className,
  pauseOnHover = true,
  ...props 
}) => {
  const content = (
    <span className="inline-flex items-center gap-8 whitespace-nowrap">
      {children}
    </span>
  );

  return (
    <div 
      className={cn(
        'overflow-hidden whitespace-nowrap',
        pauseOnHover && '[&:hover_.marquee-content]:animation-play-state-paused',
        className
      )}
      {...props}
    >
      <motion.div
        className="marquee-content inline-flex"
        animate={{
          x: direction === 'left' ? ['0%', '-50%'] : ['-50%', '0%'],
        }}
        transition={{
          duration: speed,
          ease: 'linear',
          repeat: Infinity,
        }}
      >
        {content}
        {content}
      </motion.div>
    </div>
  );
};

export const LogoMarquee = ({ logos, className, ...props }) => {
  return (
    <MarqueeText className={className} speed={30} {...props}>
      {logos.map((logo, index) => (
        <div
          key={index}
          className="flex items-center justify-center px-8 opacity-50 hover:opacity-100 transition-opacity"
        >
          {typeof logo === 'string' ? (
            <img 
              src={logo} 
              alt={`Partner ${index + 1}`}
              className="h-8 w-auto grayscale hover:grayscale-0 transition-all"
            />
          ) : (
            logo
          )}
        </div>
      ))}
    </MarqueeText>
  );
};

export const ValueMarquee = ({ values, className, ...props }) => {
  return (
    <MarqueeText className={className} speed={20} {...props}>
      {values.map((value, index) => (
        <span
          key={index}
          className="inline-flex items-center gap-4 text-lg sm:text-xl font-display font-bold text-muted-foreground/40"
        >
          {value}
          <span className="text-orange">•</span>
        </span>
      ))}
    </MarqueeText>
  );
};

export default MarqueeText;
